// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".maincontent[data-v-8d8edb8e]{height:100%}#main[data-v-8d8edb8e]{position:relative;margin:0}", ""]);
// Exports
module.exports = exports;
